import classNames from "classnames";
import styles from "../Digikala.module.css";

export default function DigikalaCooperation({ cooperation }) {
  return (
    <div
      className={classNames(
        "row rtl d-flex justify-content-center flex-wrap text-left py-4 shadow mt-5 border-0 mx-1",
        styles.digikalaRadius
      )}
      style={{ backgroundColor: cooperation.bgColor }}
    >
      <div className="col col-12 col-md-7 d-flex flex-column justify-content-center align-middle pt-2 pb-1 flex-col">
        <h1 className="text-secondary font-weight-bold fs-2 text-purple">
          {cooperation.title}
        </h1>
        <p className="text-dark pt-2 font-weight-bold">
          {cooperation.subtitle}
        </p>
      </div>

      <div className="col col-12 col-md-5 d-flex justify-content-center pt-3 pt-md-0">
        <img
          src={cooperation.image}
          className={styles.digikalaRadius}
          style={{ width: "100%" }}
          alt="تصویر هیرو"
        />
      </div>
    </div>
  );
}
